import store from '@store/index'

function AdminGuard(to, from, next) {
  let user = store.getters['auth/user']

  if (!user) {
    const query = to.query;
    if (to.path) {
      query.path = to.path
    }
    next({ name: 'login', query })
  } else if (user.role !== 'Admin') {
    next('/')
  } else {
    next()
  }
}

export default AdminGuard
